/**
 * @generated SignedSource<<1d210ee84970ae62d39d78c845836466>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TurnListProvider_salesAssociateTrackingFlow$data = {
  readonly " $fragmentSpreads": FragmentRefs<"utils_buildOccurrencesTrees">;
  readonly " $fragmentType": "TurnListProvider_salesAssociateTrackingFlow";
};
export type TurnListProvider_salesAssociateTrackingFlow$key = {
  readonly " $data"?: TurnListProvider_salesAssociateTrackingFlow$data;
  readonly " $fragmentSpreads": FragmentRefs<"TurnListProvider_salesAssociateTrackingFlow">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TurnListProvider_salesAssociateTrackingFlow",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "utils_buildOccurrencesTrees",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/)
              ],
              "type": "LostReason",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "color",
                  "storageKey": null
                },
                (v0/*: any*/),
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "positioningRule",
                  "storageKey": null
                }
              ],
              "type": "Occurrence",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v0/*: any*/),
                (v2/*: any*/)
              ],
              "type": "OccurrenceReference",
              "abstractKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SalesAssociateTrackingServiceFlowTree",
          "kind": "LinkedField",
          "name": "trees",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "paths",
              "storageKey": null
            },
            (v2/*: any*/)
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "SalesAssociateTrackingFlow",
  "abstractKey": null
};
})();

(node as any).hash = "eb4fb761ed8ab8de4d9b1d169294cb03";

export default node;
